<div *ngIf="checkViewMode('edit')" class="form-group switch-group currency">
  <label for="">
    {{attribute.key}}
    <span class="error-indication" *ngIf="true">*</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" [popover]="getOptionByKey(attribute,'tooltip')"
    placement="right"
    container="body"
    triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <div>
    <ui-switch [checked]="hasValue() ? true : false" [disabled]="disabled ? true : false" (valueChange)="onValueChange($event)"></ui-switch>
    <input type="text" [tabindex]="getOptionByKey(attribute,'tabIndex')" [maxlength]="getOptionByKey(attribute,'maxlength')" currencyMask
      [(ngModel)]="attribute.value" [placeholder]="getOptionByKey(attribute,'placeholder')" [disabled]="!valueChange || disabled ? true : false"
      class="form-control">
  </div>
</div>

<div *ngIf="checkViewMode('view') && attribute.value!=''&&attribute.value!= null"  class="m-budget">
  <!-- <div class="m-budget">
    <span class="m-budget__price m--font-brand">
      {{attribute.value | currency:'R$'}}
    </span>
    <span _ngcontent-c4="" class="m-budget__desc">{{getOptionByKey(attribute,'hideTitle')== 'true'? '' :
      attribute.key}} </span>
  </div> -->
  <p *ngIf="attribute.value!= '0'" class="m-budget__desc"><span>{{getOptionByKey(attribute,'hideTitle')== 'true'? '' :
    attribute.key}}:</span>{{ attribute.value | currency:'R$'}} </p>
</div>

<div *ngIf="checkViewMode('view') && !attribute.value" class="m-budget">
    <p class="m-budget__desc"><span>{{getOptionByKey(attribute,'hideTitle')== 'true'? '' :
        attribute.key}}:</span>Valor não informado</p>
</div>
